import { useUser } from '../../../redux/reducer/user';
import { buffs } from '../../../constants/components/features/buffs/list';
import { useContent } from '../../../redux/reducer/content';
import useDebounce from '../optimization/useDebounce';
import { useTranslation } from '../../../translations';

export const useFilteredBuffs = () => {
  const { profile } = useUser();
  const { state } = useContent();
  const { t } = useTranslation();

  const debounceState = useDebounce(state);

  return buffs.reduce((acc, { type, field, timerUntil, isAvailable, timerElapsed, timerStart, reward }) => {
    const isBuff = profile[field];

    if (!isBuff || !isAvailable({ state: debounceState })) return acc;

    acc.push({
      title: t(`buffs.${type}.title`),
      reward,
      until: profile[timerUntil],
      elapsed: profile[timerElapsed],
      from: profile[timerStart],
    });

    return acc;
  }, []);
};
